export const tournaments = [
  {
    id: 1,
    name: 'Live Roulette Championship',
    casino: 'Flagman',
    prizePool: '1000000₽',
    startDate: '2026-01-15',
    endDate: '2026-01-31',
    participants: 2847,
    game: 'Lightning Roulette',
    minBet: '100₽',
    status: 'active',
    image: 'https://public.readdy.ai/ai/img_res/197b8cb9c07dd86e3ab8cf1220ff9327.jpg'
  },
  {
    id: 2,
    name: 'Blackjack Masters Series',
    casino: 'Martin',
    prizePool: '750000₽',
    startDate: '2026-01-10',
    endDate: '2026-01-25',
    participants: 1923,
    game: 'Blackjack VIP',
    minBet: '200₽',
    status: 'active',
    image: 'https://readdy.ai/api/search-image?query=blackjack%20cards%20table%20professional%20dealer%20hands%20elegant%20casino%20tournament%20atmosphere%20dark%20luxurious%20background%20premium%20quality&width=600&height=400&seq=tournament-002&orientation=landscape'
  },
  {
    id: 3,
    name: 'Crazy Time Mega Race',
    casino: 'STARDA',
    prizePool: '2000000₽',
    startDate: '2026-01-20',
    endDate: '2026-02-10',
    participants: 4521,
    game: 'Crazy Time',
    minBet: '50₽',
    status: 'upcoming',
    image: 'https://readdy.ai/api/search-image?query=colorful%20game%20show%20wheel%20fortune%20bright%20lights%20entertainment%20casino%20tournament%20festive%20atmosphere%20dark%20background%20premium%20quality&width=600&height=400&seq=tournament-003&orientation=landscape'
  },
  {
    id: 4,
    name: 'Baccarat Elite Challenge',
    casino: 'IRWIN',
    prizePool: '1500000₽',
    startDate: '2026-01-05',
    endDate: '2026-01-20',
    participants: 1456,
    game: 'Baccarat Salon Privé',
    minBet: '500₽',
    status: 'active',
    image: 'https://readdy.ai/api/search-image?query=elegant%20baccarat%20table%20cards%20chips%20luxury%20casino%20vip%20atmosphere%20dark%20sophisticated%20background%20premium%20quality&width=600&height=400&seq=tournament-004&orientation=landscape'
  }
];